import React, { useState } from 'react'
import axios from 'axios'

const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoibGVra293aWxsaWFtdG9ycmVzIiwiYSI6ImNsdThnazlyZDBmcXEya29qMmZndGtmMmkifQ.kwHp_K24hVrkVHWqTE9yEQ'

type MapboxFeature = {
  place_name: string
  geometry?: {
    coordinates?: [number, number]
  }
}

type Props = {
  value?: string | null
  onChange: (address: string) => void
  onSelect?: (payload: { address: string; lat?: number; lon?: number }) => void
  name?: string
  placeholder?: string
  inputClassName?: string
  disabled?: boolean
}

export function AddressAutocomplete({
  value,
  onChange,
  onSelect,
  name = 'address',
  placeholder = 'Digite o endereço',
  inputClassName = 'form-control form-control-lg',
  disabled = false,
}: Props) {
  const [suggestions, setSuggestions] = useState<MapboxFeature[]>([])

  const fetchSuggestions = async (input: string) => {
    if (input.length < 3) {
      setSuggestions([])
      return
    }

    try {
      const response = await axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(input)}.json`,
        {
          params: {
            access_token: MAPBOX_ACCESS_TOKEN,
            autocomplete: true,
            types: 'place,address',
            language: 'pt-BR',
          },
        }
      )

      setSuggestions(response.data.features || [])
    } catch (error) {
      console.error('Erro ao buscar sugestões de endereço:', error)
      setSuggestions([])
    }
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value
    onChange(nextValue)
    fetchSuggestions(nextValue)
  }

  const handleSelectSuggestion = (suggestion: MapboxFeature) => {
    const address = suggestion.place_name
    const coordinates = suggestion.geometry?.coordinates
    const lat = coordinates ? coordinates[1] : undefined
    const lon = coordinates ? coordinates[0] : undefined

    onChange(address)
    onSelect?.({ address, lat, lon })
    setSuggestions([])
  }

  return (
    <div style={{ position: 'relative' }}>
      <input
        type='text'
        name={name}
        placeholder={placeholder}
        className={inputClassName}
        value={value ?? ''}
        disabled={disabled}
        onChange={handleInputChange}
        autoComplete='off'
      />
      {suggestions.length > 0 && (
        <ul
          style={{
            listStyleType: 'none',
            padding: 0,
            marginTop: '10px',
            marginBottom: 0,
            position: 'absolute',
            zIndex: 1050,
            width: '100%',
            background: 'var(--bs-body-bg, #fff)',
            border: '1px solid var(--bs-border-color, #ccc)',
            borderRadius: '0.475rem',
            maxHeight: '220px',
            overflowY: 'auto',
            boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
          }}
        >
          {suggestions.map((suggestion, index) => (
            <li
              key={`${suggestion.place_name}-${index}`}
              style={{
                padding: '10px',
                borderBottom: '1px solid var(--bs-border-color, #ccc)',
                cursor: 'pointer',
              }}
              onMouseDown={(e) => {
                e.preventDefault()
                handleSelectSuggestion(suggestion)
              }}
            >
              {suggestion.place_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
